<template>
  <div class="terms-wrapper">
    <v-container class="root">
      <v-row class="title">
        <v-col cols="9" class="title-text">
          <sc-text :field="this.fields.BoxTitle" />
        </v-col>
        <v-col
          cols="3"
          class="title-print text-right"
          v-bind:class="{
            'title-print': true,
            'text-right': true,
            'pr-0': $vuetify.breakpoint.xsOnly,
          }"
        >
          <v-icon @click="print()" class="icon" color="white" left>mdi-printer</v-icon>
          <span class="print-label" @click="print()" v-if="$vuetify.breakpoint.smAndUp">Print</span>
        </v-col>
      </v-row>
      <SubsetView
        class="ml-4 ml-sm-0 mr-4 mr-sm-0 mt-2"
        v-if="$vuetify.breakpoint.xsOnly"
        :termsAndConditions="fields"
      />

      <v-row v-else>
        <v-col class="pa-0">
          <v-card tile class="mx-auto pt-4 pl-8 pr-8">
            <SubsetView :termsAndConditions="fields" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="print">
      <v-row>
        <v-col>
          <sc-image :media="this.fields.ChallengerLogo" />
        </v-col>
        <v-col class="text-right">
          <sc-image :media="this.fields.AppLogo" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="print-header">
          <sc-text :field="this.fields.BoxTitle" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="print-body">
          <sc-rich-text :field="fields.TermsAndConditionsContent" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { RichText, Text, Image } from '@sitecore-jss/sitecore-jss-vue';
import SubsetView from './SubsetView';
export default {
  name: 'TermsAndConditions',
  components: { SubsetView, ScRichText: RichText, ScText: Text, ScImage: Image },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
.terms-wrapper {
  background: map-deep-get($colors, 'white-off', 'base');
  min-height: 80vh;
}
.card-container {
  width: 100%;
}
.root {
  @media print {
    display: none;
  }
  max-width: 576px;
}
.row {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    margin-left: -12px !important;
    margin-right: -12px !important;
  }
}
.v-input__slot {
  margin-bottom: 0px !important;
}
.terms {
  height: 60vh;
  background-color: map-deep-get($colors, 'blue-banner', 'white');
  border: 1px solid map-deep-get($colors, 'blue-banner', 'grey-lightest');
  box-sizing: border-box;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.25);
  overflow: scroll;
}
.print-label {
  cursor: pointer;
}
.title {
  color: map-deep-get($colors, 'white', 'base');
  background-color: map-deep-get($colors, 'blue-banner', 'base');
  font-size: 22px;
  line-height: 1.3;
  height: 41px;
  max-width: 576px;
}
.title-text {
  line-height: 0.9;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 16px !important;
    line-height: 1.5;
  }
  @media (max-width: 355px) {
    font-size: 14px !important;
    line-height: 1.5;
  }
}
.title-print {
  line-height: 0.9;
}
.print {
  height: 100px; // This is to fix IE11 adding blank pages in the print
}
.print-header {
  margin-top: 20px;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  color: map-deep-get($colors, 'black', 'base');
}
.print-body {
  margin-top: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: map-deep-get($colors, 'black', 'base');
}

@media screen {
  .print {
    display: none;
  }
}
</style>
